import React from 'react'
import { twMerge } from 'tailwind-merge'
import { EntityControll } from './EntityControll'

type AddEntityProps = {
  position: 'top' | 'bottom'
  backgroundColor: string
  handleClick: (event: React.SyntheticEvent) => void
}

const AddEntity = ({ position, backgroundColor, handleClick }: AddEntityProps) => {
  return (
    <EntityControll
      onClick={handleClick}
      style={{ backgroundColor }}
      className={twMerge(
        'absolute left-1/2 -translate-x-1/2 cursor-pointer',
        position === 'top' && 'top-0 -translate-y-1/2',
        position === 'bottom' && 'bottom-0 translate-y-1/2',
      )}
    >
      <span className="fas fa-plus" />
    </EntityControll>
  )
}

export default AddEntity
